// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { fontConfig } from "@stoneage/XDL/constants";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import IconArrowDownLightSmall from "@stoneage/XDL/Icons/IconArrowDownLightSmall";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        panelProps: {
            css: css`
                border: 0;
                background: ${color("common.ui4")};
                padding: 8px;
                font-size: ${fontConfig.xSmallSingleLine.size}px;
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                letter-spacing: 0;
            `,
        },
        titleTypographyProps: {
            ...fontConfig.xSmallSingleLine,
            weight: fontConfig.weight.medium,
            css: css`
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                letter-spacing: 0;
            `,
        },
        headerProps: {
            css: css`
                &&& button {
                    padding: 8px;
                    background: ${color("common.ui4")};
                    gap: 4px;
                    border: 0;
                    &:focus {
                        border-width: 0;
                        padding: 8px;
                    }
                }
            `,
        },
        toggleIconProps: {
            src: IconArrowDownLightSmall,
            color: "common.ui7",
            size: 14,
        },
    },
} as xBaseTheme["accordion"];
